import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { createFeaturesService } from './features-service-factory.function';
import { AccountFeatureGuard, FeaturesService } from './services';

@NgModule({})
export class FeaturesManagementModule {
  static forRoot(): ModuleWithProviders<FeaturesManagementModule> {
    return {
      ngModule: FeaturesManagementModule,
      providers: [
        { provide: FeaturesService, useFactory: createFeaturesService, deps: [Injector] },
        AccountFeatureGuard
      ],
    };
  }
}
